import { Alert, Stack, Typography } from "@mui/material";

const PatientAssistantEmptyState = () => {
    return (
        <Alert severity="warning" sx={{ alignItems: 'flex-start' }}>
            <Stack spacing={1.5}>
                <Typography variant="h6" fontWeight="bold">Analizza con l'AI</Typography>
                <Typography variant="body1">
                    Seleziona uno o piu' valori per l'Analisi della Seduta oppure seleziona almeno 2 file per attivare il Monitoraggio del percorso (consigliato dopo 3-4 sedute).
                </Typography>
            </Stack>
        </Alert>
    );
};

export default PatientAssistantEmptyState;
